import Api from '@/api/api'

export default {
    getTenantDetails(productID) {
        return Api.get(`saasAdmin/api/TenantConfig/TenantsByProduct/${productID}`)
    },
    getYears() {
        return Api.get('saasAdmin/api/TenantConfig/TenantCreatedYears')
    },
    getTenantDetailsOnYear(data) {
        return Api.get(`saasAdmin/api/TenantConfig/TenantsByProductYearWise/${data.productID}/${data.year}`)
    },
    getProducts() {
        return Api.get('SaasAdmin/Product/GetProducts')
    },
    getTenantTripDetailsOnProductName(data,year) {
        return Api.get(`saasAdmin/api/TenantConfig/GetTenantDataForChart?productName=${data}`+`&year=${year}`)
    },
    getTenantDetailsOnProductName(data) {
        return Api.get(`saasAdmin/api/TenantConfig/GetTenantDataForChart?productName=${data}`)
    },
}